import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import { UserInfoGetResponse } from "@/types/swagger";
import API from "@/api";

export interface ILoginUserState {
  user_id: number;
  company_id: number;
  last_name: string;
  first_name: string;
  last_name_kana: string;
  first_name_kana: string;
  email: string;
  sync_target_group_id: number; // 同期対象グループID
  account_use_start_date?: string; // アカウント利用開始日 ex. 2017-07-21
  account_use_end_date?: string; // アカウント利用終了日 ex. 2017-07-21
  updated_date_time: string; // 更新日時(UTC) ex. 2017-07-21T17:32:28Z 更新時の排他制御に使用する。
}

const initialState: ILoginUserState = {
  user_id: -1,
  company_id: -1,
  last_name: "",
  first_name: "",
  last_name_kana: "",
  first_name_kana: "",
  email: "",
  sync_target_group_id: -1, // 同期対象グループID
  updated_date_time: "", // 更新日時(UTC) ex. 2017-07-21T17:32:28Z 更新時の排他制御に使用する。
};

export interface IChangePasswordParameters {
  user_id: number;
  access_token: string;
  current_password: string;
  new_password: string;
}
@Module({
  name: "LoginUser",
  stateFactory: true,
  namespaced: true,
})
export class LoginUser extends VuexModule {
  public loginUser: ILoginUserState = initialState;

  public get getLoginUser(): ILoginUserState {
    return this.loginUser;
  }

  @Mutation set(loginUser: ILoginUserState) {
    this.loginUser = loginUser;
  }

  @Action({ rawError: true })
  public init() {
    this.set(initialState);
  }

  @Action({ rawError: true })
  public async changePassword(
    params: IChangePasswordParameters
  ): Promise<void> {
    const api = new API();
    await api.put(`/users/${params.user_id}/password`, {
      body: {
        access_token: params.access_token,
        current_password: params.current_password,
        new_password: params.new_password,
      },
    });
  }

  @Action({ rawError: true })
  public async fetchLoginUser(): Promise<void> {
    const api = new API();
    const response: UserInfoGetResponse = await api.get(`/users/executor`, {});
    if (response.user_info) {
      if (
        response.user_info.account_use_start_date &&
        response.user_info.company_id &&
        response.user_info.email &&
        response.user_info.first_name &&
        response.user_info.first_name_kana &&
        response.user_info.last_name &&
        response.user_info.last_name_kana &&
        response.user_info.sync_target_group_id &&
        response.user_info.updated_date_time &&
        response.user_info.user_id
      ) {
        const loginUser: ILoginUserState | any = {};
        for (const [key, value] of Object.entries(response.user_info)) {
          loginUser[key] = value;
        }
        this.set(loginUser);
      }
    }
  }
}
